import { render, staticRenderFns } from "./RoleStatusesActions.vue?vue&type=template&id=a09d8770&"
import script from "./RoleStatusesActions.vue?vue&type=script&lang=js&"
export * from "./RoleStatusesActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports